import React, { useState, useEffect } from 'react';
import { noticeAPI } from '../../services/api';
import { Link } from 'react-router-dom';
import PageTitle from '../shared/PageTitle';

const AdminRules = () => {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Handler to delete a rule
  const handleDelete = async (ruleId) => {
    if (window.confirm('Are you sure you want to delete this rule?')) {
      try {
        await noticeAPI.deleteRule(ruleId);
        setRules(prev => prev.filter(r => r.id !== ruleId));
      } catch (err) {
        console.error('Error deleting rule:', err);
        setError('Failed to delete rule.');
      }
    }
  };

  useEffect(() => {
    const fetchRules = async () => {
      try {
        const response = await noticeAPI.getRules();
        setRules(response.data);
      } catch (err) {
        console.error('Error fetching rules:', err);
        setError('Failed to load rules.');
      } finally {
        setLoading(false);
      }
    };
    fetchRules();
  }, []);

  if (loading) {
    return (
      <div className="container-fluid mt-4 activity-container">
        <PageTitle icon="fa-gavel" title="Manage Rules" />
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid mt-4 activity-container">
        <PageTitle icon="fa-gavel" title="Manage Rules" />
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-4 activity-container">
      <PageTitle 
        icon="fa-gavel" 
        title="Manage Rules" 
        action={
          <Link to="/admin/rules/new" className="btn btn-primary">
            <i className="fas fa-plus me-2"></i>Create New Rule
          </Link>
        }
      />
      {rules.length === 0 ? (
        <div className="alert alert-info">
          <i className="fas fa-info-circle me-2"></i>
          No rules found.
        </div>
      ) : (
        <div className="card">
          <div className="card-body p-0">
            <ul className="list-group list-group-flush">
              {rules.map(rule => (
                <li key={rule.id} className="list-group-item d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{rule.title}</strong>
                    <p className="mb-0 text-muted">{rule.description}</p>
                  </div>
                  <div>
                    <Link to={`/admin/rules/${rule.id}/edit`} className="btn btn-sm btn-outline-secondary me-2">
                      <i className="fas fa-edit me-1"></i>Edit
                    </Link>
                    <button onClick={() => handleDelete(rule.id)} className="btn btn-sm btn-outline-danger">
                      <i className="fas fa-trash me-1"></i>Delete
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminRules; 